module.exports = __webpack_public_path__ + "img/ellipsis.029ed591.svg";